import { type MutableRefObject, useEffect, useRef } from 'react';

const useHorizontalScroll = <T extends HTMLElement>(
  callback?: (event: WheelEvent) => void,
  enabled = true,
): MutableRefObject<T | null> => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const el = ref.current;

    if (!el || !enabled) return;

    const onWheel = (event: WheelEvent): void => {
      if (event.deltaY === 0) return;

      event.preventDefault();
      el.scrollTo({
        left: el.scrollLeft + event.deltaY,
        behavior: 'smooth',
      });

      if (callback) {
        callback(event);
      }
    };

    el.addEventListener('wheel', onWheel, { passive: false });

    return (): void => el.removeEventListener('wheel', onWheel);
  }, [enabled]); // важный момент — зависит от enabled

  return ref;
};

export { useHorizontalScroll };
